import { configureStore } from "@reduxjs/toolkit";
import adminAuthSlice from "./adminAuthSlice";
import adminSettingsSlice from "./adminSettingsSlice";
import aiChatSlice from "./aiChatSlice";
import announcementSlice from "./announcementSlice";
import applicationModulesSlice from "./applicationModulesSlice";
import auditLogSlice from "./auditLogsSlice";
import authSlice from "./authSlice";
import awsBucketSlice from "./awsBucketSlice";
import calendarSlice from "./calendarSlice";
import casteSlice from "./casteSlice";
import courseCategoriesSlice from "./courseCategoriesSlice";
import courseTypesSlice from "./courseTypesSlice";
import docUploadTypesSlice from "./docUploadTypesSlice";
import emailTemplatesSlice from "./emailTemplatesSlice";
import employeeAuthSlice from "./employeeAuthSlice";
import employeesAttendanceSlice from "./employeesAttendanceSlice";
import employeesSlice from "./employeesSlice";
import employeesVerificationSlice from "./employeesVerificationSlice";
import employeesWorkScheduleSlice from "./employeesWorkScheduleSlice";
import eOfficeSlice from "./eOfficeSlice";
import errorSlice from "./errorSlice";
import holidaysSlice from "./holidaysSlice";
import hrmsApiLogSlice from "./hrmsApiLogsSlice";
import idCardSlice from "./idCardSlice";
import intentSlice from "./intentSlice";
import jobNaturesSlice from "./jobNaturesSlice";
import languagesSlice from "./languageSlice";
import leaveSlice from "./leaveSlice";
import loginLogsSlice from "./loginLogsSlice";
import masterBeaconSlice from "./masterBeaconSlice";
import masterCourseDepartmentsSlice from "./masterCourseDepartmentsSlice";
import masterDnrSlice from "./masterDnrSlice";
import sapMasterStatusState from "./masterStatusSlice";
import masterStaysSlice from "./masterStaySlice";
import modesOfCourseSlice from "./modesOfCourseSlice";
import nocExIndiaSlice from "./nocExIndiaSlice";
import nocHigherEducationSlice from "./nocHigherEducationSlice";
import nocOnlineCoursesSlice from "./nocOnlineCoursesSlice";
import nocOutjobSlice from "./nocOutjobSlice";
import nocChatSlice from "./nocOutsideJobChatSlice";
import nocPassportSlice from "./nocPassportSlice";
import nocReimbursementSlice from "./nocReimbursementSlice";
import nocSapLogSlice from "./nocSapLogsSlice";
import nocTravelSlice from "./nocTravelSlice";
import notificationSlice from "./notificationsSlice";
import officeLocationSlice from "./officeLocationSlice";
import otpLogsSlice from "./otpLogsSlice";
import natureOfDutySlice from "./outsideJobNatureSlice";
import reimbursementSlice from "./reimbursementSlice";
import itDeclarationSlice from "./itDeclarationSlice";
import reportingEmployeesSlice from "./reportingEmployeesSlice";
import roleSlice from "./rolePermissionsSlice";
import sapWorklistSlice from "./sapWorklistSlice";
import settingsReducer from "./settingsSlice";
import shiftVerificationSlice from "./shiftVerificationSlice";
import sidebarSlice from "./sidebarSlice";
import smsTemplatesSlice from "./smsTemplatesSlice";
import themeSettingSlice from "./themeSettingSlice";
import usersSlice from "./usersSlice";
import vpfSlice from "./vpfSlice";
import wingDesignationDepartmentSlice from "./wingDesignationDepartmentSlice";
import workShiftSlice from "./workShiftSlice";
import staffQuarterSlice from "./staffQuarterSlice";
import milestonesSlice from "./milestonesSlice";
import darSlice from "./darSlice";

import resetLoginSlice from "./resetLoginSlice";
import eRequisitionSlice from "./eRequisitionSlice";
import sapAuthorizationSlice from "./sapAuthorizationSlice";
const store = configureStore({
  reducer: {
    themeSetting: themeSettingSlice,
    sidebarSlice: sidebarSlice,
    authState: authSlice,
    awsBucketState: awsBucketSlice,
    officeLocationState: officeLocationSlice,
    masterBeaconState: masterBeaconSlice,
    employeesState: employeesSlice,
    usersState: usersSlice,
    employeesAttendanceState: employeesAttendanceSlice,
    employeesVerificationState: employeesVerificationSlice,
    settingsState: settingsReducer,
    roleState: roleSlice,
    employeeAuthState: employeeAuthSlice,
    workShiftState: workShiftSlice,
    shiftVerificationState: shiftVerificationSlice,
    notificationsState: notificationSlice,
    reportingEmployeesState: reportingEmployeesSlice,
    leavesState: leaveSlice,
    holidaysState: holidaysSlice,
    adminAuthState: adminAuthSlice,

    employeesWorkScheduleState: employeesWorkScheduleSlice,
    adminSettingsState: adminSettingsSlice,
    applicationModulesState: applicationModulesSlice,

    languageState: languagesSlice,
    intentState: intentSlice,

    aiChatState: aiChatSlice,

    announcementState: announcementSlice,
    errorState: errorSlice,

    otpLogsState: otpLogsSlice,

    loginLogsState: loginLogsSlice,
    smsTemplatesState: smsTemplatesSlice,
    emailTemplatesState: emailTemplatesSlice,
    wingDesignationDepartmentState: wingDesignationDepartmentSlice,
    jobNaturesState: jobNaturesSlice,
    masterStaysState: masterStaysSlice,
    sapMasterStatusState: sapMasterStatusState,
    nocTravelState: nocTravelSlice,
    modesOfCourseState: modesOfCourseSlice,
    docUploadTypesState: docUploadTypesSlice,
    courseTypesState: courseTypesSlice,
    courseCategoriesState: courseCategoriesSlice,
    casteState: casteSlice,

    natureOfDutyState: natureOfDutySlice,

    nocOutjobState: nocOutjobSlice,
    nocExIndiaState: nocExIndiaSlice,
    nocChat: nocChatSlice,
    nocPassportState: nocPassportSlice,
    sapWorklistState: sapWorklistSlice,
    masterDnrState: masterDnrSlice,
    masterCourseDepartmentsState: masterCourseDepartmentsSlice,
    nocOnlineCoursesState: nocOnlineCoursesSlice,
    nocHigherEducationState: nocHigherEducationSlice,
    nocReimbursementState: nocReimbursementSlice,
    reimbursementState: reimbursementSlice,
    itDeclarationState: itDeclarationSlice,
    nocSapLogState: nocSapLogSlice,
    hrmsApiLogState: hrmsApiLogSlice,
    auditLogState: auditLogSlice,
    calendarState: calendarSlice,
    vpfState: vpfSlice,
    idCardState: idCardSlice,
    eOfficeState: eOfficeSlice,
    resetLoginSlice: resetLoginSlice,
    staffQuarterState: staffQuarterSlice,
    milestonesState: milestonesSlice,
    darState: darSlice,
    eRequisitionState: eRequisitionSlice,
    sapAuthorizationState: sapAuthorizationSlice,
  },
});

export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;

export default store;

